var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.rootClass},_vm._l((_vm.items),function(item,index){return _c('span',{key:index,class:_vm.itemClass,on:{"click":function($event){return _vm.clickHandle(item)}}},[_vm._v(" "+_vm._s(item.text)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }